import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("@keyframes spinner_xe7Q{93.75%,to{r:3px}46.875%{r:.2px}}.spinner_b2T7{animation:spinner_xe7Q .8s linear infinite}")
      ])),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createElementVNode("circle", {
      cx: "4",
      cy: "12",
      r: "3",
      class: "spinner_b2T7"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "3",
      class: "spinner_b2T7",
      style: {"animation-delay":"-.65s"}
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("circle", {
      cx: "20",
      cy: "12",
      r: "3",
      class: "spinner_b2T7",
      style: {"animation-delay":"-.5s"}
    }, null, -1))
  ]))
}
export default { render: render }